export function linkCards() {
  const cards = document.querySelectorAll('.js-linked-card');

  if (!cards) {
    return;
  }

  [].slice.call(cards).forEach(card => {
    let down = '';
    let up = '';
    let link = card.querySelector('.js-card-url');

    if (!link) {
      return;
    }

    card.style.cursor = 'pointer';
    card.onmousedown = () => down= +new Date();
    card.onmouseup = (e) => {
      if (e.button !== 0) {
        // Return if it is not a left mouse button click
        return;
      }

      up = +new Date();

      if ((up - down) < 200) {
        link.click();
      }
    }
  });
}
